import { ComponentProps, CSSProperties, FC, PropsWithChildren, useContext } from "react";
import { EnrollmentContext } from "@/state";

type ThemedTitleProps = ComponentProps<"h1">;

export const ThemedTitle: FC<PropsWithChildren<ThemedTitleProps>> = (props) => {
  const { children, style, ...headingProps } = props;
  const [state] = useContext(EnrollmentContext);
  const font = (state.experienceData?.theme as { font?: string } | undefined)?.font || "Source Sans 3";

  const themedStyle: CSSProperties = {
    fontFamily: font,
    fontWeight: 400,
    fontSize: "24px",
    ...(style || {}),
  };

  return <h1 {...headingProps} style={themedStyle}>{children}</h1>;
};
